/* Natali & Co theme scripts: cart drawer, AJAX cart, predictive search, PDP variants */
(function () {
  const money = (cents) =>
    window.Shopify && window.Shopify.formatMoney
      ? window.Shopify.formatMoney(cents)
      : (cents / 100).toFixed(2);

  /* ---------- Cart drawer ---------- */
  const drawerId = 'CartDrawer';

  function drawer() {
    return document.getElementById(drawerId);
  }

  function openDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  async function refreshCart(shouldOpen) {
    try {
      const res = await fetch(window.location.pathname + '?sections=cart-drawer', {
        headers: { 'Content-Type': 'application/json' }
      });
      const data = await res.json();
      const html = data['cart-drawer'];
      if (html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.getElementById(drawerId);
        const current = drawer();
        if (fresh && current) {
          const wasOpen = current.classList.contains('is-open');
          current.replaceWith(fresh);
          if (wasOpen || shouldOpen) fresh.classList.add('is-open');
        }
      }
      const cart = await (await fetch('/cart.js')).json();
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });
      if (shouldOpen) openDrawer();
    } catch (e) {
      console.error('Cart refresh failed', e);
    }
  }

  async function addToCart(id, quantity, button) {
    if (button) {
      button.dataset.label = button.textContent;
      button.textContent = 'Adding…';
      button.disabled = true;
    }
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity || 1 })
      });
      if (!res.ok) {
        const err = await res.json();
        alert(err.description || 'Sorry, this item could not be added.');
        return;
      }
      await refreshCart(true);
    } finally {
      if (button) {
        button.textContent = button.dataset.label || 'Add to bag';
        button.disabled = false;
      }
    }
  }

  async function changeLine(line, quantity) {
    await fetch(window.routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    });
    if (document.body.classList.contains('template--cart')) {
      window.location.reload();
    } else {
      await refreshCart(false);
    }
  }

  document.addEventListener('click', function (event) {
    const openBtn = event.target.closest('[data-cart-open]');
    if (openBtn) {
      event.preventDefault();
      refreshCart(true);
      return;
    }
    if (event.target.closest('[data-cart-close]')) {
      event.preventDefault();
      closeDrawer();
      return;
    }
    const addBtn = event.target.closest('[data-quick-add]');
    if (addBtn) {
      event.preventDefault();
      addToCart(addBtn.dataset.variantId, 1, addBtn);
      return;
    }
    const step = event.target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      const wrap = step.closest('.qty');
      const input = wrap.querySelector('input');
      const next = Math.max(0, parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10));
      input.value = next;
      if (input.dataset.line) changeLine(input.dataset.line, next);
      return;
    }
    const remove = event.target.closest('[data-line-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.lineRemove, 0);
      return;
    }
    if (event.target.closest('[data-search-toggle]')) {
      event.preventDefault();
      const sd = document.getElementById('SearchDrawer');
      if (sd) {
        sd.classList.toggle('is-open');
        const input = sd.querySelector('input[name="q"]');
        if (sd.classList.contains('is-open') && input) input.focus();
      }
      return;
    }
    if (event.target.closest('[data-menu-toggle]')) {
      event.preventDefault();
      const mn = document.getElementById('MobileNav');
      if (mn) mn.classList.toggle('is-open');
    }
  });

  document.addEventListener('change', function (event) {
    const input = event.target.closest('.qty input[data-line]');
    if (input) changeLine(input.dataset.line, parseInt(input.value, 10));
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeDrawer();
  });

  /* ---------- PDP add to cart ---------- */
  document.addEventListener('submit', function (event) {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    const id = form.querySelector('[name="id"]').value;
    const qtyEl = form.querySelector('[name="quantity"]');
    addToCart(id, qtyEl ? parseInt(qtyEl.value, 10) : 1, form.querySelector('[type="submit"]'));
  });

  /* ---------- Variant selection ---------- */
  document.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
    const data = JSON.parse(picker.querySelector('[data-variants-json]').textContent);
    const form = document.querySelector('[data-product-form]');
    if (!form) return;

    function selected() {
      return Array.from(picker.querySelectorAll('input:checked')).map((i) => i.value);
    }

    picker.addEventListener('change', function () {
      const values = selected();
      const match = data.find((v) => v.options.every((o, i) => o === values[i]));
      const idInput = form.querySelector('[name="id"]');
      const priceEl = document.querySelector('[data-pdp-price]');
      const submit = form.querySelector('[type="submit"]');
      if (!match) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = 'Unavailable';
        }
        return;
      }
      idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (submit) {
        submit.disabled = !match.available;
        submit.textContent = match.available ? 'Add to bag' : 'Sold out';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
      const media = document.querySelector('[data-pdp-main-image]');
      if (media && match.featured_image) media.src = match.featured_image;
    });
  });

  /* ---------- PDP gallery ---------- */
  document.querySelectorAll('[data-thumb]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const main = document.querySelector('[data-pdp-main-image]');
      if (main) main.src = btn.dataset.thumb;
      document
        .querySelectorAll('[data-thumb]')
        .forEach((b) => b.setAttribute('aria-current', String(b === btn)));
    });
  });

  /* ---------- Predictive search ---------- */
  let searchTimer;
  document.addEventListener('input', function (event) {
    const input = event.target.closest('[data-predictive-input]');
    if (!input) return;
    const results = document.querySelector('[data-predictive-results]');
    clearTimeout(searchTimer);
    if (input.value.trim().length < 2) {
      if (results) results.innerHTML = '';
      return;
    }
    searchTimer = setTimeout(async function () {
      const url =
        window.routes.predictive_search_url +
        '?q=' +
        encodeURIComponent(input.value) +
        '&resources[type]=product,collection,page&resources[limit]=6&section_id=predictive-search';
      const res = await fetch(url);
      const html = await res.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const list = parsed.querySelector('[data-predictive-results]');
      if (results && list) results.innerHTML = list.innerHTML;
    }, 220);
  });

  /* ---------- Sort / facet auto-submit ---------- */
  document.querySelectorAll('[data-auto-submit]').forEach(function (el) {
    el.addEventListener('change', function () {
      el.closest('form').submit();
    });
  });

  /* ---------- Skin guide finder ---------- */
  const guide = document.querySelector('[data-skin-guide]');
  if (guide) {
    guide.addEventListener('click', function (event) {
      const chip = event.target.closest('[data-guide-option]');
      if (!chip) return;
      guide.querySelectorAll('[data-guide-option]').forEach((c) => c.classList.remove('is-active'));
      chip.classList.add('is-active');
      guide.querySelectorAll('[data-guide-result]').forEach(function (panel) {
        panel.hidden = panel.dataset.guideResult !== chip.dataset.guideOption;
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('reveal');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    document.querySelectorAll('[data-reveal]').forEach((el) => io.observe(el));
  }

  window.NataliTheme = { addToCart, refreshCart, openDrawer, closeDrawer, money };
})();
